<!-- **** --------------------------------------------------------------------------
	SHARED SCRIPT
-------------------------------------------------------------------------- **** -->
<script lang="ts">
    import vm from '@journeys/Journeys.viewmodel';
</script>

<!-- **** --------------------------------------------------------------------------
	SCRIPT
-------------------------------------------------------------------------- **** -->
<script lang="ts" setup>
    // components
    import FluidButton from '@shared/components/FluidButton.vue';
    import dataview from './dataview.vue';
    import nodeInspection from './nodeInspection.vue';
    import inputsPreview from '../previews/inputs.vue';

    import { bitshift } from '@shared/utils';
    import { computed, ref } from 'vue';

    const { canvas, editor, nav, settings } = vm;

    const props = defineProps<{}>();

    const activeTab = ref('data');
    const tabComponent = computed(() => {
        switch (activeTab.value) {
            case 'data':
                return dataview;
            case 'node':
                return nodeInspection;
            case 'inputpreview':
                return inputsPreview;
            default:
                return;
        }
    });
    const switchTab = (tab: string) => {
        activeTab.value = tab;
    };
</script>

<!-- **** --------------------------------------------------------------------------
	TEMPLATE
-------------------------------------------------------------------------- **** -->
<template>
    <div style="height: 100%">
        <div style="padding-right: 1rem">
            <h3 class="title">Developer Menu</h3>
            <div class="tab-container fl">
                <FluidButton text="Data" :class="['tab-underline', activeTab === 'data' ? 'active' : '']" @click="() => switchTab('data')" />
                <FluidButton text="Node" :class="['tab-underline', activeTab === 'node' ? 'active' : '']" @click="() => switchTab('node')" />
                <FluidButton text="Inputs" :class="['tab-underline', activeTab === 'inputpreview' ? 'active' : '']" @click="() => switchTab('inputpreview')" />
            </div>
        </div>
        <component style="height: 93%" :is="tabComponent"></component>
    </div>
</template>

<!-- **** --------------------------------------------------------------------------
	STYLES
-------------------------------------------------------------------------- **** -->
<style></style>
